import { GenericRecord } from '@/modules/core/data/record';
import { CustomerTheme } from '@/modules/core/data/types/CustomerTheme';
import {
  ReactSelectTheme,
  selectStyles,
} from '@/modules/core/reactSelect/reactSelect';
import { isMobileDevice } from '@/utils/mobile';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

import ChatbotQuestion from '@/modules/core/data/types/CDE/ChatbotQuestion';
import {
  FormatGroupLabel,
  GetOptionLabel,
  OnChange,
} from './MultiSelectInput';

type Props = {
  question: ChatbotQuestion;
  selectedValue: GenericRecord;
  onChange: OnChange;
  getOptionLabel?: GetOptionLabel;
  formatGroupLabel?: FormatGroupLabel;
  theme: CustomerTheme;
}

const SingleSelectInput: React.FunctionComponent<Props> = (props): JSX.Element => {
  const {
    question,
    selectedValue,
    onChange,
    getOptionLabel: customGetOptionLabel,
    formatGroupLabel = undefined,
    theme,
  } = props;
  const { t } = useTranslation();

  const defaultGetOptionLabel = (choice: GenericRecord): string => {
    return choice?.label;
  };
  const getOptionLabel = customGetOptionLabel || defaultGetOptionLabel;
  const choices: any[] = (question?.choices || []) as any[];// eslint-disable-line @typescript-eslint/no-explicit-any

  return (
    <div>
      <Select
        className={'select select-multi'}
        isMulti={false}
        value={selectedValue || null} // Force to null if value is null-ish, otherwise it'll keep displaying the previous selected one
        options={choices}
        getOptionValue={(choice: GenericRecord): string => {
          return choice?.id;
        }}
        getOptionLabel={getOptionLabel}
        onChange={(selectedChoice: GenericRecord, action: { action: string }): void => {
          onChange(selectedChoice);
        }}
        styles={selectStyles}
        theme={(defaultTheme: ReactSelectTheme): ReactSelectTheme => {
          return {
            ...defaultTheme,
            colors: {
              ...defaultTheme.colors,
              primary: theme.primaryColor,
            },
          };
        }}
        placeholder={t('chatbotPage.multiSelectInput.selectFilter.placeholder', 'Choisir')}
        noOptionsMessage={(inputValue: string): React.ReactNode => t('chatbotPage.multiSelectInput.selectFilter.noMatchFound', 'Aucun résultat')}
        closeMenuOnSelect={true}
        blurInputOnSelect={false} // Workaround to closeMenuOnSelect that actually works on Android Chrome - See https://github.com/JedWatson/react-select/issues/2771
        formatGroupLabel={formatGroupLabel}
        isSearchable={!isMobileDevice()} // Don't allow to search on mobile, avoids to display the keyboard
      />
    </div>
  );
};

export default SingleSelectInput;

